module.exports = __webpack_public_path__ + "media/images/flags/4x3/grc-ee8135c60d62d9a0ab6cadd840818706.svg";